export class NotificationStats {
  unread?: number;
  currentPage?: number;
  totalPages?: number;


  constructor(unread: number, currentPage: number, totalPages: number) {
    this.unread = unread;
    this.currentPage = currentPage;
    this.totalPages = totalPages;
  }
}
